module.exports = "https://cdn.realtymogul.com/static/media/HP_card_lakeside_at_town.69724d87.jpg";